import ScrollReveal from '@/components/base/ScrollReveal';
import { Link } from 'react-router-dom';
import personalImage from '@/images/credito-personal.jpeg';
import pymeImage from '@/images/credito-pyme.jpeg';
import distribuidorImage from '@/images/distribuidor.jpeg';
interface ProductCard {
  id: string;
  title: string;
  subtitle: string;
  description: string;
  amountLabel: string;
  amountValue: string;
  termLabel: string;
  termValue: string;
  icon: string;
  variant: 'personal' | 'pyme' | 'distribuidor';
  features: string[];
  image: string;
}

const products: ProductCard[] = [
  {
    id: 'personal',
    title: 'Crédito Personal',
    subtitle: 'Para ti',
    description: 'Préstamos diseñados para tus necesidades personales, con trámites rápidos y condiciones flexibles que se adaptan a tu estilo de vida.',
    amountLabel: 'Monto',
    amountValue: '$5,000 - $50,000',
    termLabel: 'Plazo',
    termValue: 'Hasta 18 meses',
    icon: 'ri-user-star-line',
    variant: 'personal',
    features: ['Sin aval requerido', 'Tasa fija competitiva', 'Sin penalización por pago anticipado', 'Seguro de vida incluido'],
    image: personalImage,
  },
  {
    id: 'pyme',
    title: 'Crédito PyME',
    subtitle: 'Para tu empresa',
    description: 'Financiamiento estratégico para impulsar el crecimiento de tu empresa con soluciones diseñadas a la medida de tu negocio.',
    amountLabel: 'Monto',
    amountValue: '$50,000 - $1,000,000',
    termLabel: 'Plazo',
    termValue: 'Hasta 24 meses',
    icon: 'ri-building-2-line',
    variant: 'pyme',
    features: ['Análisis financiero personalizado', 'Sin comisión por apertura', 'Tasa fija competitiva', 'Sin penalización por pago anticipado'],
    image: pymeImage,
  },
  {
    id: 'distribuidor',
    title: 'Conviértete en Distribuidor',
    subtitle: 'Emprende tu negocio',
    description: 'Líneas de crédito exclusivas para iniciar o expandir tu negocio como distribuidor de vales de dinero, con condiciones preferenciales.',
    amountLabel: 'Monto',
    amountValue: 'Sujeto a evaluación',
    termLabel: 'Plazo',
    termValue: 'Revolvente',
    icon: 'ri-store-3-line',
    variant: 'distribuidor',
    features: ['Capacitación inicial gratuita', 'Comisiones atractivas', 'Sin inversión inicial', 'Soporte continuo'],
    image: distribuidorImage,
  },
];

export default function Solutions() {
  return (
    <section id="soluciones" className="relative py-20 md:py-28 overflow-hidden" style={{ background: 'oklch(var(--background-50))' }}>
      <div className="relative z-10 max-w-[1440px] mx-auto px-6 md:px-10">
        <ScrollReveal animation="fade-up" duration={600}>
          <div className="text-center mb-16">
            <div className="inline-flex items-center gap-3 mb-4">
              <span className="w-8 h-px rounded-full bg-accent-500/30"></span>
              <span className="text-accent-600 text-sm font-semibold tracking-widest uppercase">Soluciones Financieras</span>
              <span className="w-8 h-px rounded-full bg-accent-500/30"></span>
            </div>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
              El crédito{' '}
              <span className="relative">
                <span className="relative z-10 bg-gradient-to-r from-accent-600 to-accent-500 bg-clip-text text-transparent">
                  perfecto
                </span>
              </span>
              {' '}para cada uno
            </h2>
            <p className="mt-4 text-foreground-500 text-base max-w-xl mx-auto">
              Tres productos diseñados para acompañarte en cada momento de tu crecimiento personal y empresarial.
            </p>
          </div>
        </ScrollReveal>

        <div className="flex flex-col lg:flex-row gap-6 items-stretch">
          {products.map((product, index) => (
            <ScrollReveal key={product.id} animation="fade-up" delay={index * 150} duration={700} className="flex-1 self-stretch">
              <div
                className="flex flex-col h-full rounded-3xl overflow-hidden transition-all duration-500 group hover:-translate-y-2 border border-background-200/60"
                style={{ background: 'oklch(var(--background-50))' }}
              >
                <div className="relative h-52 overflow-hidden">
                  <img
                    src={product.image}
                    alt={product.title}
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                  />

                  <div className="absolute top-4 right-4 z-10">
                    <span className="px-3 py-1.5 rounded-full text-xs font-semibold bg-background-50/90 text-foreground-700 backdrop-blur-sm whitespace-nowrap">
                      {product.subtitle}
                    </span>
                  </div>

                  <div className="absolute bottom-4 left-4 z-10">
                    <div className="w-12 h-12 rounded-2xl flex items-center justify-center text-white" style={{ background: 'oklch(var(--accent-500))' }}>
                      <i className={`${product.icon} text-xl`}></i>
                    </div>
                  </div>
                </div>

                <div className="p-8">
                  <div className="min-h-[3rem] md:min-h-[4.5rem] flex items-end mb-3">
                    <h3 className="text-2xl md:text-3xl font-bold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
                      {product.title}
                    </h3>
                  </div>

                  <p className="text-foreground-500 text-sm leading-relaxed mb-6">
                    {product.description}
                  </p>

                  <div className="flex gap-6 mb-6 p-4 rounded-2xl" style={{ background: 'oklch(var(--background-100))' }}>
                    <div className="flex-1">
                      <span className="text-[10px] text-foreground-400 uppercase tracking-widest font-semibold">{product.amountLabel}</span>
                      <div className="text-lg font-bold text-foreground-950 mt-1 whitespace-nowrap" style={{ fontFamily: 'var(--font-heading)' }}>
                        {product.amountValue}
                      </div>
                    </div>
                    <div className="w-px bg-background-300"></div>
                    <div className="flex-1">
                      <span className="text-[10px] text-foreground-400 uppercase tracking-widest font-semibold">{product.termLabel}</span>
                      <div className="text-lg font-bold text-foreground-950 mt-1 whitespace-nowrap" style={{ fontFamily: 'var(--font-heading)' }}>
                        {product.termValue}
                      </div>
                    </div>
                  </div>

                  <div className="flex flex-wrap gap-2 mb-8">
                    {product.features.map((feat, fi) => (
                      <span
                        key={fi}
                        className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-medium bg-accent-50 text-accent-700"
                      >
                        <i className="ri-check-double-line text-[10px]"></i>
                        {feat}
                      </span>
                    ))}
                  </div>

                  {product.id === 'personal' ? (
                    <Link
                      to="/credito-personal"
                      className="inline-flex items-center gap-2 px-6 py-3.5 bg-accent-500 text-white text-sm font-semibold rounded-full hover:bg-accent-400 transition-all duration-300 hover:scale-[1.04] active:scale-[0.97] cursor-pointer whitespace-nowrap group/btn"
                    >
                      Más Información
                      <i className="ri-arrow-right-line transition-transform duration-300 group-hover/btn:translate-x-1"></i>
                    </Link>
                  ) : product.id === 'pyme' ? (
                    <Link
                      to="/credito-pyme"
                      className="inline-flex items-center gap-2 px-6 py-3.5 bg-accent-500 text-white text-sm font-semibold rounded-full hover:bg-accent-400 transition-all duration-300 hover:scale-[1.04] active:scale-[0.97] cursor-pointer whitespace-nowrap group/btn"
                    >
                      Más Información
                      <i className="ri-arrow-right-line transition-transform duration-300 group-hover/btn:translate-x-1"></i>
                    </Link>
                  ) : (
                    <Link
                      to="/conviertete-en-distribuidor"
                      className="inline-flex items-center gap-2 px-6 py-3.5 bg-accent-500 text-white text-sm font-semibold rounded-full hover:bg-accent-400 transition-all duration-300 hover:scale-[1.04] active:scale-[0.97] cursor-pointer whitespace-nowrap group/btn"
                    >
                      Más Información
                      <i className="ri-arrow-right-line transition-transform duration-300 group-hover/btn:translate-x-1"></i>
                    </Link>
                  )}
                </div>
              </div>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
}